import Request, { Methods } from '@libraries/request/'
import ModelHero from '@models/hero'

export default class Hero extends Request {
  constructor(options) {
    super()
    this.series = options.seriesId
    this.hero = options.heroId
  }

  get path() {
    return '/apis/hero'
  }

  get method() {
    return Methods.post
  }

  get parameters() {
    const params = {}
    params.series_id = this.series
    params.hero_id = this.hero
    return params
  }

  decode({ data }) {
    return new ModelHero(data)
  }

  decodeError(error) {
    return { error: error }
  }
}
